import PropTypes from 'prop-types';
import React from 'react';

import NormalFormButton from './NormalFormButton';

class PrimaryFormButton extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.any,
      onClick: PropTypes.func,
      disabled: PropTypes.bool,
      className: PropTypes.string,
    };
  }

  render() {
    return (
      <NormalFormButton color="primary" {...this.props}>
        {this.props.children}
      </NormalFormButton>
    );
  }
}

export default PrimaryFormButton;
